import { render } from "./Partner.vue?vue&type=template&id=6e5473a0&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"

import "./Partner.vue?vue&type=style&index=0&id=6e5473a0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5473a0"]])

export default __exports__